module.exports = {"title":"Новогодняя шпаргалка для родителей","description":"«Летидор» подготовил пошаговую инструкцию по подготовке к празднику для родителей – новогодний адвент-календарь","image":"http://nycalendar.letidor.ru/img/share.jpg","url":"http://nycalendar.letidor.ru/","fbappid":594585344218936,"trackingID":"UA-105301080-26","clientTrackingID":"","top100":0,"clientTop100":0,"yaMetrika":17175679}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 4
// module chunks = 0